import { render, staticRenderFns } from "./courseListEdit_new.vue?vue&type=template&id=50fbc786&scoped=true"
import script from "./courseListEdit_new.vue?vue&type=script&lang=js"
export * from "./courseListEdit_new.vue?vue&type=script&lang=js"
import style0 from "./courseListEdit_new.vue?vue&type=style&index=0&id=50fbc786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fbc786",
  null
  
)

export default component.exports